import { render, staticRenderFns } from "./ModalUnlinkGroup.vue?vue&type=template&id=79519e79&"
import script from "./ModalUnlinkGroup.vue?vue&type=script&lang=js&"
export * from "./ModalUnlinkGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports